import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dropdownMenuContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${theme.palette.border.main} !important`,
        },
    },
    inputLabel: {
        color: `${theme.palette.primary.dark} !important`,
        textAlign: "left",
    },
    select: {
        backgroundColor: theme.palette.secondary.main,
        width: "290px",
        height: "45px",
        borderRadius: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        marginBottom: "5px",
        " & .MuiSelect-select": {
            textAlign: "left",
        },
    },
    menuItemContainer: {
        color: theme.palette.text.primary,
        textAlign: "left",
    },
    menuItem: {
        color: theme.palette.text.primary,
        display: "flex",
        gap: "13px",
        alignItems: "center",
    },
    imageContainer: {
        display: "flex",
    },
    image: {
        maxWidth: 34,
        height: 34,
        borderRadius: "100%",
    },
    name: {
        textAlign: "left",
    },
    noPictureIcon: {
        fontSize: "40px !important",
    },
}));
